// Copy of the customer website's built-in top menu (aavryaa_frontend Constants/menuItems.js).
// The Website Menu editor starts from this when no custom menu has been saved yet.
// `category` is the product category the item belongs to (used by Add/Edit Product).
export const DEFAULT_SITE_MENU = [
  {
    "label": "FABRICS",
    "dropdown": [
      {
        "label": "Georgette",
        "path": "/collections/georgette-fabric"
      },
      {
        "label": "Ikkath cotton",
        "path": "/collections/ikkat-cotton-fabric",
        "subcategories": [
          {
            "label": "Japan Satin",
            "path": "/collections/japan-satin-fabric"
          }
        ]
      },
      {
        "label": "Twile delight",
        "path": "/collections/twile-delight-fabric"
      },
      {
        "label": "Viscose",
        "path": "/collections/viscose-fabric"
      },
      {
        "label": "Checked Cotton",
        "path": "/collections/checked-cotton-fabric"
      },
      {
        "label": "Dupion Digital",
        "path": "/collections/dupion-digital-fabric"
      },
      {
        "label": "Organza",
        "path": "/collections/organza-fabric"
      },
      {
        "label": "Organza Printed",
        "path": "/collections/organza-printed-fabric"
      },
      {
        "label": "Organza Sequence",
        "path": "/collections/organza-sequence-fabric"
      },
      {
        "label": "Brocade Shiny",
        "path": "/collections/brocade-shiny-fabric"
      },
      {
        "label": "Banarasi Brocade",
        "path": "/collections/banarasi-brocade-fabric"
      },
      {
        "label": "Brasso Net",
        "path": "/collections/brasso-net-fabric"
      },
      {
        "label": "Embroidery Cotton",
        "path": "/collections/embroidery-cotton-fabric"
      },
      {
        "label": "Embroidery Net",
        "path": "/collections/embroidery-net-fabric"
      },
      {
        "label": "Shimmer Net",
        "path": "/collections/shimmer-net-fabric"
      },
      {
        "label": "Plain Net",
        "path": "/collections/plain-net-fabric"
      },
      {
        "label": "Georgette Floral Sequence",
        "path": "/collections/georgette-floral-sequence-fabric"
      },
      {
        "label": "Kalamkari",
        "path": "/collections/kalamkari-fabric"
      },
      {
        "label": "Lace Net",
        "path": "/collections/lace-net-fabric"
      },
      {
        "label": "Lycra",
        "path": "/collections/lycra-fabric"
      },
      {
        "label": "Plain Cotton",
        "path": "/collections/plain-cotton-fabric"
      },
      {
        "label": "Plain Georgette",
        "path": "/collections/plain-georgette-fabric"
      },
      {
        "label": "Printed Cotton",
        "path": "/collections/printed-cotton-fabric"
      },
      {
        "label": "Printed Satin",
        "path": "/collections/printed-satin-fabric"
      },
      {
        "label": "Silicon Georgette",
        "path": "/collections/silicon-georgette-fabric"
      },
      {
        "label": "Viscose Organza",
        "path": "/collections/viscose-organza-fabric"
      },
      {
        "label": "Satin Georgette",
        "path": "/collections/satin-georgette-fabric"
      },
      {
        "label": "Chiffon",
        "path": "/collections/chiffon-fabric"
      }
    ],
    "category": "fabrics"
  },
  {
    "label": "SAREES",
    "dropdown": [
      {
        "label": "Designer Saree",
        "path": "/collections/designer-sarees"
      },
      {
        "label": "Dupion Saree",
        "path": "/collections/dupion-sarees"
      },
      {
        "label": "Tissue Zardozi Saree",
        "path": "/collections/tissue-zardozi-sarees"
      },
      {
        "label": "Ikkath Pochampalli Saree",
        "path": "/collections/ikkath-pochamali-sarees"
      },
      {
        "label": "Ikkath Saree",
        "path": "/collections/ikkath-sarees"
      },
      {
        "label": "Kota Silk Cotton Saree",
        "path": "/collections/kota-silk-cotton-sarees"
      },
      {
        "label": "Banarasi silk Saree",
        "path": "/collections/banarasi-silk-sarees"
      },
      {
        "label": "Raw Mango Silk Saree",
        "path": "/collections/raw-mango-silk-sarees"
      },
      {
        "label": "Orange Floral Saree",
        "path": "/collections/orange-floral-sarees"
      },
      {
        "label": "Tissue Banarasi Saree",
        "path": "/collections/tissue-banarsi-sarees"
      },
      {
        "label": "Tissue Antique Saree",
        "path": "/collections/tissue-antique-sarees"
      },
      {
        "label": "Tussar Meenakari Saree",
        "path": "/collections/tussar-meenakari-sarees"
      },
      {
        "label": "Kora Antique Saree",
        "path": "/collections/kora-antique-sarees"
      },
      {
        "label": "Kora Designer Saree",
        "path": "/collections/kora-designer-sarees"
      },
      {
        "label": "Dupion Rankat Saree",
        "path": "/collections/dupion-rankat-sarees"
      },
      {
        "label": "Banarasi Tissue Saree",
        "path": "/collections/banarszi-tissue-sarees"
      },
      {
        "label": "Silk Cotton Saree",
        "path": "/collections/silk-cotton-sarees"
      },
      {
        "label": "Pure Silk Saree",
        "path": "/collections/pure-silk-sarees"
      },
      {
        "label": "Chandheri Silk Saree",
        "path": "/collections/chandhiri-silk-sarees"
      },
      {
        "label": "Cotton Saree",
        "path": "/collections/cotton-sarees"
      },
      {
        "label": "Mulberry-Cotton Saree",
        "path": "/collections/mulbery-cotton-sarees"
      }
    ],
    "category": "sarees"
  },
  {
    "label": "CUSTOMIZED FABRICS",
    "path": "/collections/customized-fabrics",
    "category": "customized-fabrics"
  },
  {
    "label": "AAVRYAAS EXCLUSIVE",
    "path": "/collections/aavryaas-exclusive-fabrics",
    "category": "aavryaas-exclusive-fabrics"
  },
  {
    "label": "VINTAGE COLLECTION",
    "path": "/collections/vintage-collection",
    "category": "vintage-collection"
  },
  {
    "label": "PRICE RANGE",
    "priceFilter": true,
    "category": ""
  }
];
